<template>
  <div class="categories pt-0 pb-0 task-page">
    <div class="learning-header">
      <span class="f-w-600">Tasks</span>
    </div>

    <div v-if="tasks_data" class="mt-4 position-relative" style="padding: 0 30px">
      <div
          class="card task-card"
          v-for="(task, index) in tasks_data"
          :key="index"
        >
          <div class="card-body">

            <h6 class="f-w-600">{{ task.title }} <span class="badge badge-success ml-2" v-if="task.isRequired">Required</span></h6>
            <p class="mr-3">{{ task.description }}</p>

            <div class="actions-wrapper">
              <button class="btn btn-light" v-b-tooltip.hover.left title="Edit" @click="openTask(task)">
                <i class="fa fa-edit"></i>
              </button>
            </div>

            <div class="row task-statistic" v-if="task.taskSchedule">
              <div class="col-md-12 task-date-section" v-if="task.taskSchedule.length">
                <div class="d-flex">
                  <div class="col-4 text-md-right border-right">
                    <span>Scheduled Start</span>
                    <div class="follow-num counter mt-1" v-for="(item, i) in task.taskSchedule" :key="i">{{dateFormat(item.scheduledDate)}}</div>
                  </div>
                  <div class="col-4 text-md-center border-right">
                    <span>Scheduled End</span>
                    <div class="follow-num counter mt-1" v-for="(item, i) in task.taskSchedule" :key="i">
                      {{dateFormat(addMinutesToDate(item.scheduledDate, task.timeAllotmentSection))}}
                    </div>
                  </div>
                  <div class="col-4 text-md-left">
                    <span>Completed Date</span>
                    <div class="follow-num counter mt-1" v-for="(item, i) in task.taskSchedule" :key="i">{{ item.completedDate ? dateFormat(item.completedDate) : '---'}}</div>
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <div class="user-profile mb-4" v-if="task.link">
              <div class="ttl-info text-left link">
                <h6><i class="fa fa-link mr-2"></i>Link</h6>
                <span>
                <a :href="task.link" v-b-tooltip.hover :title="task.link" target="_blank">{{ task.link }}</a>
              </span>
              </div>
            </div>


            <div class="d-flex justify-content-between">
              <div class="user-profile">
                <div class="ttl-info text-left dayTimeSection" v-if="task.dayTimeSection">
                  <h6><i class="fa fa-clock-o mr-2"></i>Day Time</h6>
                  <span>{{ task.dayTimeSection }}</span>
                </div>
                <div class="ttl-info text-left repeatingDaysOfWeek" v-if="task.daysOfWeek">
                  <h6><i class="fa fa-calendar mr-2"></i>Days of Week</h6>
                  <span v-for="(day, index) in task.daysOfWeek" :key="index">{{ checkWeekDayName(day.dayName) }}</span>
                </div>
                <div class="ttl-info text-left location" v-if="task.location">
                  <h6><i class="fa fa-location-arrow mr-2"></i>Location</h6>
                  <span>{{ task.location }}</span>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>

    <div v-else style="padding: 10px 30px;">
      <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert alert-secondary outline alert-secondary">
        <p>There are no Tasks yet</p>
      </div>
    </div>

    <b-modal ref="edit-task" title="Edit task" hide-footer no-close-on-backdrop>
      <form @submit.prevent="handleEdit">
        <div class="form-group">
          <label for="task-edit-title">Title</label>
          <input type="text" v-model="taskEdit.title" id="task-edit-title" name="title" class="form-control" :class="{ 'is-invalid': submittedEdit && $v.taskEdit.title.$error }" />
          <div v-if="submittedEdit && !$v.taskEdit.title.required" class="invalid-feedback">Title is required</div>
        </div>
        <div class="form-group">
          <label for="task-edit-description">Description</label>
          <textarea rows="4" type="text" v-model="taskEdit.description" id="task-edit-description" name="description" class="form-control" :class="{ 'is-invalid': submittedEdit && $v.taskEdit.description.$error }"> </textarea>
          <div v-if="submittedEdit && !$v.taskEdit.description.required" class="invalid-feedback">Description is required</div>
        </div>
        <div class="form-group">
          <button class="btn btn-primary" type="submit">Save Changes</button>
          <a class="btn btn-light ml-2" href="#" @click.prevent="$refs['edit-task'].hide()">Cancel </a>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import moment from "moment";

  export default {
    name: "tasks",
    props: {
      user_tasks: {
        type: [Array, Object],
        default: undefined
      }
    },
    data() {
      return {
        draggingItem: [],
        tasks_data: [],
        openTask_data: [],
        isDragging: true,
        taskEdit: {
          userTaskId: "",
          title: "",
          description: "",
        },
        daysOfWeekOptions: [
          { dayName: 'Sunday', text: 'Sun'},
          { dayName: 'Monday', text: 'Mon'},
          { dayName: 'Tuesday', text: 'Tues'},
          { dayName: 'Wednesday', text: 'Wed'},
          { dayName: 'Thursday', text: 'Thurs'},
          { dayName: 'Friday', text: 'Fri'},
          { dayName: 'Saturday', text: 'Sat'},
        ],
        submittedEdit: false,
      }
    },
    validations: {
      taskEdit: {
        title: { required },
        description: { required },
      }
    },
    created() {
      this.init();
    },
    methods: {
      dateFormat(date) {
        return moment(date).format('LLL')
      },
      addMinutesToDate(date, minutes){
        return moment(date).add(minutes, 'm');
      },
      init() {
        this.tasks_data = this.user_tasks;
      },
      async handleEdit() {

        this.submittedEdit = true;

        this.$v.taskEdit.$touch();
        if (this.$v.taskEdit.$invalid) {
          return;
        }

        this.taskEdit.name = this.taskEdit.title;

        let res = await this.$store.dispatch('editUserTask', this.taskEdit);
        if (res.status === 200) {
          this.$toasted.show(' Successfully done ', {
            theme: 'bubble',
            position: "top-right",
            type: 'success',
            duration: 2000
          });
          this.$refs['edit-task'].hide();
          this.tasks_data.forEach((val) => {
            if(val.id === this.taskEdit.userTaskId) {
              val.title = this.taskEdit.title;
              val.description = this.taskEdit.description;
            }
          })
        }
      },
      openTask(task) {
        this.taskEdit.title = task.title;
        this.taskEdit.name = task.title;
        this.taskEdit.description = task.description;
        this.taskEdit.userTaskId = task.id;
        this.$refs['edit-task'].show()
      },
      checkWeekDayName(item) {
        let text = "";
        this.daysOfWeekOptions.forEach((val) => {
          if (
            val.dayName.toLowerCase() === item.toLowerCase() ||
            val.text.toLowerCase() === item.toLowerCase()
          ) {
            text = val.text
          }
        });

        return text;
      },
      trimMyString(string, maxLength, isSpace, start = 0) {
        if (string.length > maxLength) {
          let trimmedString = string.substr(start, maxLength);
          return (
              trimmedString.substr(
                  start,
                  Math.min(trimmedString.length, isSpace ? trimmedString.lastIndexOf(' ') : trimmedString.lastIndexOf(''))
              ) + ' ...'
          )
        }
        return string
      },
    }
  }
</script>

<style scoped lang="scss">
  .task-statistic {
    margin: 1rem 0;

    .task-date-section {
      background: #f6f7fb;
      padding: 1rem 0;

      span {
        color: #4365f2;
        font-size: 15px;
        font-weight: 600;
      }
    }

    .task-completion {
      padding: 1rem;
    }
  }

  .categories .learning-header {
    display: flex;
    justify-content: space-between;
    padding-right: 30px;
  }
  .custom-select {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }
  .invalid-feedback {
    display: block;
  }
  .custom-control {
    padding-left: 18px;
    z-index: 0;
  }
  .buttons {
    margin-top: 35px;
  }
  .ghost {
    overflow: hidden;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1111;
      background-color: #afe4ff;
    }
  }
  .task-content-info {
    display: flex;
    flex-direction: column;
  }
  .user-profile {
    display: flex;

    &.in-modal {
      flex-direction: column;

      .ttl-info {
        margin-bottom: 15px;
        &.repeatingDaysOfWeek {
          width: 100%;

          &>div {
            display: flex;
            flex-wrap: wrap;

            span {
              margin-bottom: 5px;
            }
          }
        }
      }
    }

    .ttl-info {
      margin-right: 20px;
      width: max-content;

      h6 {
        margin-bottom: 5px;
      }

      &.dayTimeSection {
        span {
          background: #1fa4ec;
          color: #fff;
          padding: 2px 7px;
          border-radius: 5px;
        }
        h6 {
          color: #1da6ec;
        }
      }

      &.repeatingDaysOfWeek {
         span {
           background: #4365f2;
           color: #fff;
           padding: 2px 7px;
           border-radius: 5px;
           margin-right: 5px;
         }
         h6 {
           color: #4365f2;
         }
       }

      &.link {
        span {
          margin-right: 5px;

          a {
            color: #1b252a;
          }
        }
        h6 {
          color: #22af48;
        }
      }
    }
  }

  .task-content-info-inModal {
    display: flex;
    flex-direction: column;
    width: 50%;

    &:first-child {
      padding-right: 10px;
    }

    &:last-child {
      padding-left: 10px;
    }
  }

  .isDragging {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1113;
  }

  .task-card {
    position: relative;
    overflow: hidden;

    .actions-wrapper {
      position: absolute;
      right: 0;
      top: 36px;
      flex-direction: column;

      button {
        padding: 10px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0;

        i {
          margin: 0;
        }
      }
    }

    .move-btn {
      position: absolute;
      top: 0;
      right: 0;
      overflow: hidden;
      opacity: 0;
      transition: 0.3s;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: move;
      background-color: #8ba2c4;

      img {
        width: 18px;
        height: 18px;
        margin: 0;
      }
    }

    &:hover .move-btn {
      overflow: visible;
      opacity: 1;
    }
  }
</style>
